/**
 * A consulta de mídia (`matchMedia`) bate agora? Atualiza quando a janela muda. Sem `matchMedia` (testes, SSR) vale `false`.
 */
import { useCallback, useSyncExternalStore } from 'react';

const matcher = (query) => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query) : null);

/** @param {string} query ex.: '(max-width: 639px)' @returns {boolean} */
export function useMediaQuery(query) {
    // A identidade de `subscribe` só muda com a consulta: senão o React reassinaria a cada renderização
    const subscribe = useCallback((notify) => {
        const mq = matcher(query);
        if (!mq) return () => {};
        mq.addEventListener?.('change', notify);
        return () => mq.removeEventListener?.('change', notify);
    }, [query]);
    const snapshot = useCallback(() => matcher(query)?.matches ?? false, [query]);
    return useSyncExternalStore(subscribe, snapshot, () => false);
}
